<template>
  <div>
    Header Default v0.2
    <ul>
      <li>
        <router-link :to="{ name: 'homePage' }">Home</router-link>
      </li>
      <li>
        <router-link :to="{ name: 'pricingPage' }">Pricing</router-link>
      </li>
      <li>
        <router-link :to="{ name: 'contactPage' }">Contact us</router-link>
      </li>
      <li>
        <router-link :to="{ name: 'loginPage' }"
          >Login (hide when logged)</router-link
        >
      </li>
      <li>
        <router-link :to="{ name: 'store' }"
          >Dashboard (Show When logged)</router-link
        >
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "HeaderDefault"
};
</script>
<style scoped lang="scss">
@import "@/assets/style/css/generic-variables.scss";
</style>
